import { Card, Grid } from "@mui/material";
import { useGlobalMarketProductPriceChartContext } from "../../../context/global-market/GlobalMarketProductPriceChartContext";
import { CustomAutocomplete } from "../../../components/custom/CustomAutocomplete";
import { sendData } from "../../../lib/dashboard/actions";
import { BarChartOutlined } from "@mui/icons-material";
import useResponsive from "../../../components/hooks/useResponsive";
import AddToFavoritesButton from "../../../components/favorite/AddToFavoritesButton";
import { mutate } from "swr";
import Loading from "../../../components/loader/Loading";

const GlobalMarketProductPriceChartForm = () => {
  const {
    industries,
    commodityTypes,
    commodities,
    transitTypes,
    selected,
    setSelected,
    isLoadingChart,
    handleShowChart,
    isFavoritesValidation,
  } = useGlobalMarketProductPriceChartContext();

  const { isXl, isLg } = useResponsive();

  const { industry, commodityType, commodity, transitType } = selected;

  const body = {
    industry_id: industry?.id,
    commodity_type_id: commodityType?.id,
    commodity_id: commodity?.id,
    transit_id: transitType?.id,
  };

  const handleAddToFavorite = async () => {
    const res = await sendData(body, "/favorite/global-favorite-price-chart");
    if (res.status === 200)
      await mutate("/favorite/global-favorite-price-chart");
  };

  const clearForm = (field) => {
    switch (field) {
      case "industry":
        setSelected((prev) => ({
          ...prev,
          commodityType: null,
          commodity: null,
          transitType: null,
        }));
        break;
      case "commodityType":
        setSelected((prev) => ({
          ...prev,
          commodity: null,
          transitType: null,
        }));
        break;
      case "commodity":
        setSelected((prev) => ({
          ...prev,
          transitType: null,
        }));
        break;
      default:
        break;
    }
  };

  const isDisabled = [industry?.id, commodityType?.id].every(Boolean);

  return (
    <Card>
      <Grid container spacing={1} alignItems={"center"}>
        {isLg && (
          <Grid item xs={12} md={6} lg={isXl ? 0.5 : 1}>
            <AddToFavoritesButton
              onClick={handleAddToFavorite}
              isDisabled={!isDisabled}
              style={{ height: "43px" }}
              isLoading={isFavoritesValidation}
            />
          </Grid>
        )}

        <Grid item xs={12} md={6} lg={2.5}>
          <CustomAutocomplete
            options={industries.data}
            value={industry}
            onChange={(e, newValue) => {
              setSelected((prev) => ({ ...prev, industry: newValue }));
              clearForm("industry", newValue);
            }}
            isLoading={industries.isLoading}
            placeholder="صنعت"
          />
        </Grid>

        <Grid item xs={12} md={6} lg={2.5}>
          <CustomAutocomplete
            options={commodityTypes.data}
            value={commodityType}
            onChange={(e, newValue) => {
              setSelected((prev) => ({ ...prev, commodityType: newValue }));
              clearForm("commodityType", newValue);
            }}
            isLoading={commodityTypes.isLoading}
            placeholder="نوع کالا"
          />
        </Grid>
        <Grid item xs={12} md={6} lg={2.5}>
          <CustomAutocomplete
            options={commodities.data}
            value={commodity}
            onChange={(e, newValue) => {
              setSelected((prev) => ({ ...prev, commodity: newValue }));
              clearForm("commodity", newValue);
            }}
            isLoading={commodities.isLoading}
            placeholder="کالا (اختیاری)"
          />
        </Grid>
        <Grid item xs={12} md={6} lg={2.5}>
          <CustomAutocomplete
            options={transitTypes.data}
            value={transitType}
            onChange={(e, newValue) => {
              setSelected((prev) => ({ ...prev, transitType: newValue }));
              clearForm("transitType", newValue);
            }}
            isLoading={transitTypes.isLoading}
            placeholder="نوع حمل و نقل (اختیاری)"
          />
        </Grid>
        <Grid item xs={10} lg={isXl ? 1.5 : 1}>
          <button
            style={{ height: "43px" }}
            onClick={() => handleShowChart(body)}
            className={`btn ${!isDisabled ? " btn-softblue" : "btn-blue"}`}
            disabled={!isDisabled || isLoadingChart}
          >
            {isLoadingChart ? (
              <Loading color={"#fff"} />
            ) : (
              <>
                {(isXl || !isLg) && "نمایش"}
                <BarChartOutlined />
              </>
            )}
          </button>
        </Grid>

        {!isLg && (
          <Grid item xs={2}>
            <AddToFavoritesButton
              onClick={handleAddToFavorite}
              isDisabled={!isDisabled}
              style={{ height: "43px" }}
              isLoading={isFavoritesValidation}
            />
          </Grid>
        )}
      </Grid>
    </Card>
  );
};

export default GlobalMarketProductPriceChartForm;
